import { render, staticRenderFns } from "./RegistrationLayout.vue?vue&type=template&id=9b3a65be"
import script from "./RegistrationLayout.vue?vue&type=script&lang=js"
export * from "./RegistrationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports